export default __webpack_public_path__ + "static/media/itemsIcon.8c4de207.svg";